import { defineMessages } from 'react-intl';

export default defineMessages({
  validValuesHeader: {
    id: 'ValidValuesHeader.validValuesHeader',
    defaultMessage: '{attribute} allows the following valid values and ranges:',
  },
});
